import React, { useEffect, useState } from "react";
import {
    Route,
    Switch,
    useLocation,
    withRouter,
    Redirect,
    useHistory,
} from "react-router-dom";
import ReactNotification from "react-notifications-component";
import { connect } from "react-redux";
import { useMsal } from '@azure/msal-react';

import Protected from "../../containers/authentication.HOC";

import SignIn from "../../containers/authentication/signin";
import ResetPassword from "../authentication/resetPassword/resetPassword";
import CreateProfile from "../authentication/createProfile/createProfile";
import CreatePassword from "../authentication/createPassword/createPassword.jsx";

import authenicationImage from "../../assets/images/arch.jpg";
import LogoFooter from "../common/logoFooter/LogoFooter";
import { doLogout, handleAuthLogout } from "../../utils";
import useGAEventTracker from '../utils/hooks/GAEventsTracker';
import Cookies from "universal-cookie";
import AdminIcon from "../../assets/images/userWithFill.svg"
import TooltipAndInfoForImage from "../TooltipAndInfo/toolTipandInfoForImage.js";
const ProtectedSignin = Protected(SignIn, true);
const ProtectedResetPass = Protected(ResetPassword, true);
const ProtectedCreateProfile = Protected(CreateProfile);
const ProtectedCreatePassword = Protected(CreatePassword, true);

const Authenication = ({ session }) => {
    const [isAdmin, setIsAdmin] = useState(false);
    const [loginPage, setLoginPage] = useState(false);
    const { pathname } = useLocation();
    const isLoggedIn = session?.isLoggedIn;
    const isAzureMFAEnabled = process.env.REACT_APP_IS_AZURE_MFA_ENABLED;
    const history = useHistory();
    const { instance, accounts } = useMsal();
    const GAEventsTracker = useGAEventTracker("Logout Event");
    const [showLoginTooltip, setShowLoginTooltip] = useState(false);


    useEffect(()=>{
        if(localStorage.getItem('signOut') === 'yes') 
        {
            const cookies = new Cookies();
            const role = cookies.get("role")
            doLogout();
            GAEventsTracker("logout");
            localStorage.removeItem('signOut')
            const redirectUrl = process.env.REACT_APP_HOST !== 'https://temp.clcafamily.com' ? '/obituaries' : '/'
            if(isAzureMFAEnabled.toLowerCase() === "true" && role === "cl-arranger") handleAuthLogout(instance, accounts, redirectUrl)
        }
    },[])

    let clsName =
        "authenication-content d-md-flex align-items-md-center justify-content-md-center";
    if (loginPage) {
        clsName = clsName + " limited-height";
    }

    const showHideLinkToolTip = () => {
        setShowLoginTooltip(!setShowLoginTooltip);
    };

    return (
        <div className='authenication-section'>
            <ReactNotification />
            <div className={clsName}>
                <div className='auth-leftsection d-none d-md-block'>
                    <img
                        src={authenicationImage}
                        alt='Celebrating Life'
                        className='authenication-img'
                    />
                </div>
                {!isAdmin && pathname === "/" ? (
                    <TooltipAndInfoForImage
                        icon={AdminIcon}
                        showTooltipFn={showHideLinkToolTip}
                        showToolTip={showLoginTooltip}
                        tooltipText={'Login as Admin'}
                        onClick={(e) => {
                            e.preventDefault();
                            setIsAdmin(true);
                            history.push({
                            pathname: "/administrator",
                        });
                        }}
                        clsName={'btn-auth login-admin-main'}
                        id='adminLoginIcon'
                    />
                ) : null}
                <div className='auth-rightsection d-md-flex align-items-md-center justify-content-md-center'>
                    <section className='auth-content-wrapper'>
                        <Switch>
                            <Route
                                path={`/forgot-password`}
                                render={props => (
                                    <ProtectedResetPass {...props} />
                                )}
                            />
                            <Route
                                path={`/reset`}
                                render={() => <ProtectedCreatePassword />}
                            />
                            <Route
                                path={`/profile`}
                                render={() => <ProtectedCreateProfile />}
                            />
                            <Route
                                path={`/administrator`}
                                render={() => (
                                    <ProtectedSignin
                                        isAdmin="true"
                                        setLoginPage={setLoginPage}
                                        setIsAdmin={setIsAdmin}
                                    />
                                )}
                            />
                            <Route
                                path={`/`}
                                render={() => (
                                    <ProtectedSignin
                                        isAdmin={isAdmin}
                                        setLoginPage={setLoginPage}
                                        setIsAdmin={setIsAdmin}
                                    />
                                )}
                            />
                        </Switch>
                    </section>
                </div>
            </div>
            {loginPage && <LogoFooter />}
        </div>
    );
};

export default Authenication;
